var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1441_7178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.59931 16.8401C3.79931 16.8401 3.83931 16.8201 4.01931 16.7801L7.61931 16.0601C7.99931 15.9601 8.37931 15.7801 8.67931 15.4801L17.3993 6.76012C18.7393 5.42012 18.7393 3.12012 17.3993 1.78012L16.6593 1.00012C15.3193 -0.339883 12.9993 -0.339883 11.6593 1.00012L2.93931 9.74012C2.65931 10.0201 2.45931 10.4201 2.35931 10.8001L1.59931 14.4401C1.49931 15.1201 1.69931 15.7801 2.17931 16.2601C2.55931 16.6401 3.11931 16.8401 3.59931 16.8401ZM4.27931 11.1801L12.9993 2.44012C13.5793 1.86012 14.6393 1.86012 15.1993 2.44012L15.9593 3.20012C16.6393 3.88012 16.6393 4.84012 15.9593 5.50012L7.25931 14.2401L3.55931 14.8601L4.27931 11.1801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3196 18.0801H2.55961C1.97961 18.0801 1.59961 18.4601 1.59961 19.0401C1.59961 19.6201 2.07961 20.0001 2.55961 20.0001H17.2396C17.8196 20.0001 18.2996 19.6201 18.2996 19.0401C18.2796 18.4601 17.7996 18.0801 17.3196 18.0801Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1441_7178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfileIcon);
export default __webpack_public_path__ + "static/media/EditProfileIcon.4e5a9e991e0a4339ddde1c423f2cbcd4.svg";
export { ForwardRef as ReactComponent };